module.exports = __webpack_public_path__ + "img/logo-full.cf14b36a.png";